import { b as getTrustPilotInfo } from "../../../../../chunks/utils2.js";
const load = async () => {
  const trustPilotInfo = await getTrustPilotInfo();
  return {
    trustPilotInfo
  };
};
export {
  load
};
